import { render, staticRenderFns } from "./AttachmentDownloadLink.vue?vue&type=template&id=2717033d"
import script from "./AttachmentDownloadLink.vue?vue&type=script&lang=js"
export * from "./AttachmentDownloadLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports